module.exports = __webpack_public_path__ + "static/media/pimg_default_vi.10e51ec3.jpg";